import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PagedUnitOfMeasureModel, SortType, UnitOfMeasureModel, UnitOfMeasureResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxUnitOfMeasureService {
  constructor(
    private uomResourceService: UnitOfMeasureResourceService,
  ) {
  }

  getUnitOfMeasures(params?: {
    page?: number,
    limit?: number,
    orderBy?: string,
    sort?: SortType,
    query?: string,
    ids?: number[],
    includeDisabled?: boolean,
  }): Promise<PagedUnitOfMeasureModel> {
    return firstValueFrom(this.uomResourceService.getUnitOfMeasures(params?.includeDisabled, params?.limit, params?.page, params?.query));
  }

  async getUnitOfMeasuresByIds(ids: number[]): Promise<UnitOfMeasureModel[]> {
    const paged = await this.getUnitOfMeasures({ids: ids});
    return paged.list;
  }
}
